import { useDarkMode } from "./context/DarkModeContext";
import "./styles/animacion.css";
import Header from "./componentes/Header";
import Portada from "./componentes/Portada";
import Nosotros from "./componentes/Nosotros";
import Servicios from "./componentes/Servicios";
import Contacto from "./componentes/Contacto";
import IAComparacion from "./componentes/IAComparacion";
import Tecnologias from "./componentes/Tecnologias";
import Galleta from "./componentes/internos/Galleta";
import Footer from "./componentes/Footer";

export default function App() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
      className={`min-h-screen bg-white text-white dark:bg-gray-900 dark:text-gray-900`}
    >
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={toggleDarkMode}
        scrollToSection={scrollToSection}
      />
      <Portada isDarkMode={isDarkMode} scrollToSection={scrollToSection} />
      <Nosotros />
      <IAComparacion />
      <Servicios />
      <Tecnologias isDarkMode={isDarkMode} />
      <Contacto />
      <Footer scrollToSection={scrollToSection} />
      <Galleta isDarkMode={isDarkMode} />
    </div>
  );
}
